import React, { useState, useEffect } from 'react';
import BaseForm from '../../app/components/BaseForm';
import Input from '../../app/components/Input';
import Select from '../../app/components/Select';

const FormEditObligation = ({ isOpen, onClose, title, selectObligation, onSubmit }) => {
  const [formData, setFormData] = useState({
    nome: '',
    obrigacoes: '',
    departamentos: '',
  });

  useEffect(() => {
    if (selectObligation) {
      setFormData({
        id: selectObligation.id || null,
        nome: selectObligation.nome || '',
        obrigacoes: selectObligation.obrigacoes || '',
        departamentos: selectObligation.departamentos || '',
      });
    } else {
      setFormData({
        nome: '',
        obrigacoes: '',
        departamentos: '',
      });
    }
  }, [selectObligation]);

  const handleChange = (eOrValue, fieldName) => {
    if (typeof eOrValue === 'object' && eOrValue !== null && 'value' in eOrValue) {
      setFormData(prev => ({
        ...prev,
        [fieldName]: eOrValue.value,
      }));
    } else {
      const { name, value } = eOrValue.target;
      setFormData(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const obrigacoesOptions = [
    { value: 'Mensal', label: 'Mensal' },
    { value: 'Trimestral', label: 'Trimestral' },
    { value: 'Semestral', label: 'Semestral' },
    { value: 'Anual', label: 'Anual' },
  ];

  const departamentosOptions = [
    { value: 'Fiscal', label: 'Fiscal' },
    { value: 'Contábil', label: 'Contábil' },
    { value: 'Recursos Humanos', label: 'Recursos Humanos' },
    { value: 'Financeiro', label: 'Financeiro' },
    { value: 'Administrativo', label: 'Administrativo' },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit && typeof onSubmit === 'function') {
      onSubmit(formData);
    }
  };

  const renderFormField = () => {
    return (
      <div>
        <div className='pb-4'>
          <Input
            className="mt-2"
            label='Nome da obrigação'
            name='nome'
            placeholder="Digite o nome da obrigação fiscal..."
            value={formData.nome}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className='pb-4'>
          <Select
            label='Obrigação'
            placeholder="Selecione a Obrigação"
            name='obrigacoes'
            options={obrigacoesOptions}
            value={formData.obrigacoes}
            onChange={(option) => handleChange(option, 'obrigacoes')}
            className="mt-2"
            required
          />
        </div>
        
        <div className='pb-4'>
          <Select
            label='Departamento'
            placeholder="Selecione o departamento"
            name='departamentos'
            options={departamentosOptions}
            value={formData.departamentos}
            onChange={(option) => handleChange(option, 'departamentos')}
            className="mt-2"
          />
        </div>
      </div>
    );
  };

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title={title}
      className='max-w-4xl'
    >
      {renderFormField()}
    </BaseForm>
  );
};

export default FormEditObligation;